module.exports = __webpack_public_path__ + "img/图层.e632ad2f.png";